<template>
    <div>
        <div v-if="type === 'blue'" class="blue-warn">
            <img src="@/assets/images/exclamation-mark-icon.png" alt="exclamation-mark-icon" style="padding-right:20px">
            <div v-html="text"></div>
        </div>
        <div v-else :class="type === 'yellow' ? 'yellow-warn' : 'red-warn'">
            <img src="@/assets/images/info-icon.png" alt="info-icon" style="padding-right:20px">
            <div v-html="text"></div>
            <slot name="link"></slot>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            type: null,
            text: null
        },
        data() {
            return {

            }
        },
    }
</script>

<style scoped>
.blue-warn{
    background: #ffffff;
    padding: 15px 20px;
    color: #84879d;
    display: flex;
    align-items: center;
    font-size: 12px;
    margin: 10px 0;
    border: 1px solid #fff1d3;
}
.yellow-warn{
    background: #ffffff;
    padding: 15px 20px;
    color: #84879d;
    display: flex;
    align-items: center;
    font-size: 12px;
    margin: 10px 0;
    border: 1px solid #ffe6e6;
}
.red-warn{
    background: #ffffff;
    padding: 15px 20px;
    color: #84879d!important;
    display: flex;
    align-items: center;
    font-size: 12px;
    margin: 10px 0;
    border: 1px solid #ffe6e6;
}
.red-warn >>> a {
    color:#84879d!important;
}
.red-warn >>> svg{
    color: #fff !important;
}
svg{
    color: #5a5e6a;
    margin-right: 20px;
}
</style>
